/**
 * When a floating page is drawn again in the headset. Each capture rasterises the whole page on
 * the main thread, 100 to 400 ms on a Quest 2, a freeze the headset covers by reprojecting; it
 * used to run every quarter second while anything on the page changed (x-quest-vr#8). Now a page
 * is drawn once it has been quiet a moment, and not while a trigger is held on it (a slider being
 * dragged), yet never more than a second behind.
 */
export const CAPTURE_QUIET_MS = 300;
export const CAPTURE_STALE_MS = 1000;
/** The least time between two captures. */
export const CAPTURE_GAP_MS = 250;

export interface PageCaptureState {
  /** The page differs from what the headset shows. */
  dirty: boolean;
  /** A capture is running. */
  busy: boolean;
  /** No capture before this (`performance.now()` milliseconds). */
  notBefore: number;
  /** When the page last changed. */
  changedAt: number;
  /** Since when the page has differed from what the headset shows. */
  dirtySince: number;
  /** A trigger is held on the page. */
  pressed: boolean;
}

/** Whether to capture now. */
export function captureDue(state: PageCaptureState, now: number): boolean {
  if (!state.dirty || state.busy || now < state.notBefore) return false;
  const quiet = !state.pressed && now - state.changedAt >= CAPTURE_QUIET_MS;
  return quiet || now - state.dirtySince >= CAPTURE_STALE_MS;
}
